import { useState } from 'react';

import { useGenericModal } from '..';
import {
  ReportingApiCredentialModal,
  ReportingApiCredentialModalProps,
} from './reporting-api-credential-modal';

type Env = 'live' | 'sandbox';

export const useReportingApiCredentialModal = (
  props?: Partial<ReportingApiCredentialModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const [type, setType] =
    useState<ReportingApiCredentialModalProps['type']>('add');
  const [env, setEnv] = useState<Env>('live');
  const [credentialId, setCredentialId] = useState<string | undefined>();
  const [pypeId, setPypeId] = useState<string | undefined>();
  // The modal element is never unmounted — only its `open` property flips — so a
  // counter is what tells the modal a fresh open happened (it places the initial
  // focus on that). Re-opening with identical options still bumps it.
  const [openSeq, setOpenSeq] = useState(0);

  const modalComponent = (
    <ReportingApiCredentialModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      type={type}
      env={env}
      credentialId={credentialId}
      pypeId={pypeId}
      openSeq={openSeq}
    />
  );

  const openCredentialModal = (
    nextType: NonNullable<ReportingApiCredentialModalProps['type']>,
    options?: { env?: Env; credentialId?: string; pypeId?: string }
  ) => {
    setType(nextType);
    if (options?.env) setEnv(options.env);
    setCredentialId(options?.credentialId);
    setPypeId(options?.pypeId);
    setOpenSeq((seq) => seq + 1);
    openModal();
  };

  return {
    modalRef,
    openModal: openCredentialModal,
    closeModal,
    reportingApiCredentialModal: modalComponent,
  };
};
